/**
 * TyC — bloque de Términos del Servicio embebido en el panel de administración.
 *
 * Renderiza EXACTAMENTE el mismo texto que la página pública /terms
 * (src/pages/LegalPage/legalContent.js). Antes tenía su propio texto en los archivos
 * de i18n, escrito para otro producto ("Balance Score Card Digital"): dos versiones de
 * los términos conviviendo es justo lo que no puede pasar en un documento legal.
 */
import React from 'react';
import { useLanguage } from '../../i18n';
import { LegalDocument } from '../../pages/LegalPage/LegalPage';
import { getLegalDoc } from '../../pages/LegalPage/legalContent';
import '../../pages/LegalPage/legal.css';
import './tyc.css';

const TyC = () => {
    const { language } = useLanguage();
    return (
        <div className="tyc-container legal-main">
            <LegalDocument doc={getLegalDoc('terms', language)} />
        </div>
    );
};

export default TyC;
